import React from "react";
import { NavLink, useLocation } from "react-router-dom";

export function BottomTabs({ tabs }) {
    return (
        <nav
            className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-brand-charcoal/15 shadow-lift sm:relative sm:border-0 sm:shadow-none sm:bg-transparent"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            <div className="max-w-5xl mx-auto px-2 py-2 grid" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
                {tabs.map((t) => (
                    <NavLink
                        key={t.to}
                        to={t.to}
                        end={t.end}
                        data-testid={`tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className={({ isActive }) =>
                            `relative flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-xl text-[11px] font-bold uppercase tracking-wider transition-colors min-h-[56px] ${
                                isActive
                                    ? "bg-brand-navy text-brand-bone"
                                    : "text-brand-charcoal hover:bg-brand-stone"
                            }`
                        }
                    >
                        {t.badge > 0 && (
                            <span
                                data-testid={`tab-badge-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="absolute top-1 right-1/2 translate-x-4 h-4 min-w-[16px] px-0.5 bg-brand-danger text-white text-[10px] font-bold rounded-full flex items-center justify-center leading-none"
                            >
                                {t.badge > 9 ? "9+" : t.badge}
                            </span>
                        )}
                        <t.icon className="h-5 w-5" />
                        <span className="truncate w-full text-center">{t.label}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
